import { useEffect, useState } from "react";

export function usePermissions() {
  const [permissions, setPermissions] = useState<Set<string>>(new Set());
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    fetch("/api/access/me")
      .then(async (response) => {
        if (!response.ok) throw new Error(String(response.status));
        return response.json() as Promise<{ permissions: string[] }>;
      })
      .then((result) => setPermissions(new Set(result.permissions)))
      .catch(() => setPermissions(new Set()))
      .finally(() => setLoaded(true));
  }, []);
  return { permissions, loaded, has: (permission: string) => permissions.has(permission) };
}
